/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:040d3c1e-3eb5-4870-8dca-40f5ff13ac6d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_J58HeV4wS",
    "aws_user_pools_web_client_id": "35t7lgk29htc684jtus10sb0sc",
    "oauth": {
        "domain": "idapass-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://idapass.com/survey/wellcome/",
        "redirectSignOut": "https://idapass.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://wkvejeumkjadzlyf3qq7lieyzm.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
